import { Alert } from '@simplywallst/ui-core';
import type { ReactNode } from 'react';

type Props = {
  children?: ReactNode;
};

export const NarrativeGenericError = ({ children }: Props) => {
  const isValidMessage = typeof children === 'string' && children;
  return (
    <Alert styleType="negative">
      {isValidMessage
        ? children
        : 'We were unable to load Narrative page at this time. Please get in touch with our support team.'}
    </Alert>
  );
};
